

    export class parametroHeader {
        public id: string;
        public sistema: string;
        public width: number;
        public height: number;
        public url_css: string;
        public foto : string;
        public alt: string;   
        public css: string;  
        public nome: string;  
        public tipo: string; 
        public periodoEleitoral: boolean;
        public ativo: boolean;
        constructor(id: string = "",
            sistema: string = "",
            width: number = 0,
            height: number = 0,
            url_css: string= "",
            foto : string= "",
            alt: string= "",
            css: string= "",
            nome: string= "",
            tipo: string= "",
            periodoEleitoral: boolean = false,
            ativo: boolean = false) {
                this.id = id;
                this.sistema = sistema;
                this.width = width;
                this.height = height;
                this.url_css = url_css;
                this.foto = foto;
                this.alt = alt;
                this.css = css;
                this.nome = nome;
                this.tipo = tipo;
                this.periodoEleitoral= periodoEleitoral;
                this.ativo = ativo;
            }
      }